// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT

export interface RepoStat {
  repoCount: number;
  platform: string;
}

export interface RepoDetail {
  repositoryUrl: string;
  repoName: string;
  platform: string;
}

export interface RepositoryContributions {
  stats: RepoStat[];
  details: RepoDetail[];
}
